import { render, staticRenderFns } from "./old-member.vue?vue&type=template&id=a6b2ea74&scoped=true&"
import script from "./old-member.vue?vue&type=script&lang=js&"
export * from "./old-member.vue?vue&type=script&lang=js&"
import style0 from "./old-member.vue?vue&type=style&index=0&id=a6b2ea74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6b2ea74",
  null
  
)

export default component.exports